import Route from '@ember/routing/route';

export default class ScreensAppsAppRoute extends Route {
  model(): void {
    return;
  }
}
